module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b97a035e41221b6fce72d74b9933f5b2.gif";